<template>
    <admin-layout>
        <div class="content" slot="main">
            <div class="content-header">
                <h3>Scoring Models Rules <button v-if="is_admin" class="btn btn-custom" @click="toggleFilterModal()"><i class="fa fa-plus"></i> Add Rule</button></h3>
            </div>

            <div class="filter" :class="{'filter-disabled': !r.active}" v-for="(r, ir) in filtersList" :key="r.id">
                <div class="text-right filter-controls">
                    <button v-if="is_admin" :disabled="ir == 0" class="btn" @click="moveUpFilter(ir)"><i class="fa fa-arrow-up"></i></button>
                    <button v-if="is_admin" :disabled="(ir + 1) == filtersList.length" class="btn" @click="moveDownFilter(ir)"><i class="fa fa-arrow-down"></i></button>
                    <button v-if="is_admin" class="btn" @click="toggleFilterModal(r)"><i class="fa fa-pencil"></i></button>
                    <button v-if="is_admin" class="btn" @click="deleteFilter(ir)"><i class="fa fa-trash"></i></button>
                </div>
                <h5>Priority: <b>{{ ir + 1 }}</b> (Rate: <b>{{r.rate}}%</b>)</h5>
                <h5>Status: <b><span v-if="r.active">Active</span><span v-else>Inactive</span></b></h5>
                <h5>Model: <b>{{ r.scoring_model.name }}</b></h5>
                <h5 v-if="r.test_scoring_models.length">Test Models: <ul class="list-inline"><li v-for="tm in r.test_scoring_models">{{tm.name}}</li></ul></h5>
                <div class="rules">
                    <boolean-expression-widget :expression="r.rule" @updateExpression="updateExpression($event, r)"></boolean-expression-widget>
                </div>
            </div>
        </div>

        <footer slot="footer">
            <button v-if="is_admin" type="button" class="btn btn-custom" @click="saveTable()">Save</button>
        </footer>

        <div slot="modals">
            <scoring-model-rule-modal
                v-if="showFilterModal"
                :filter="filter"
                v-on:close="showFilterModal = false"
                v-on:save="saveFilter">
            </scoring-model-rule-modal>

            <rule-modal
                v-if="showRuleModal"
                :available-fields="fields"
                :condition="condition"
                v-on:close="showRuleModal = false"
                v-on:save="saveCondition">
            </rule-modal>
        </div>
    </admin-layout>
</template>

<script>
 import Vue from 'vue';


 import {AdminLayout} from 'components/layouts/';
 import {ScoringModelRuleModal, RuleModal} from 'components/modals/';
 import BooleanExpressionWidget from 'components/elements/BooleanExpressionWidget';
 import YesNo from 'components/elements/YesNo';

 // Load the full build.
 var _ = require('lodash');

 export default {
   components: {
       AdminLayout,
       BooleanExpressionWidget,
       RuleModal,
       ScoringModelRuleModal,
       YesNo,
   },
     data () {
         return {
             is_admin: false,
             loading: false,
             filter: null,
             rule: null,
             condition: null,
             rules: null,
             fields: [],
             integrations: [],
             filtersList: [],
             showFilterModal: false,
             showRuleModal: false
         };
     },
     computed: {
         fieldOptions: function () {
             return this.fields.reduce(
                 (a, x) => {
                     a[x['id']] = x;
                     return a;
                 },
                 {});
         },
     },
     created () {
         this.is_admin = this.$store.state.user.role == 'admin' ||  this.$store.state.user.role == 'superuser';
         this.fetchInitialData();
     },

     methods: {
         randomId() {
             var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
             var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
             return "temp_" + r1 + "_" + r2;
         },
       updateExpression(expr, filter) {
             filter.rule = null;
             this.$set(filter, 'rule', expr);
         },
         addRule(filter) {
             this.filter = filter;
             this.rule = {
                 'id': this.randomId(),
                 'rules': []
             };
             this.condition = undefined;
             this.showRuleModal = true;
         },
         deleteRule(filter, ir) {
             filter.predicate.allof.terms.splice(ir, 1);
         },
         addCondition(rule) {
             this.rule = rule;
             this.filter = null;
             this.condition = undefined;
             this.showRuleModal = true;
         },
         editCondition(condition, rule) {
             this.filter = null;
             this.rule = rule;
             this.condition = condition;
             this.showRuleModal = true;
         },
         deleteCondition(rule, ic) {
             rule.rules.splice(ic, 1);
         },
         saveCondition(condition) {

             var self = this;



             let i = this.rule.rules.findIndex(function (e) {
                 return (self.condition != null) && (e.id === self.condition.id);
             });

             if (i > -1) {
                 this.$set(this.rule.rules, i, condition);
             }
             else {
                 this.rule.rules.push(condition);
             }

             if (this.filter) {
                 let ir = this.filter.predicate.allof.terms.findIndex(function (e) {
                     return e.id == self.rule.id;
                 });

                 if (i == -1) {
                     this.filter.predicate.allof.terms.push(this.rule);
                 }
             }
             this.showRuleModal = false;
         },
         moveUpFilter(ir) {
             var tmp = this.filtersList[ir];
             this.$set(this.filtersList, ir, this.filtersList[ir - 1]);
             this.$set(this.filtersList, ir - 1, tmp);
         },
         moveDownFilter(ir) {
             var tmp = this.filtersList[ir];
             this.$set(this.filtersList, ir, this.filtersList[ir + 1]);
             this.$set(this.filtersList, ir + 1, tmp);
         },
         deleteFilter(ir) {
             if (confirm("Do you really want to remove filter '" + this.filtersList[ir].name + "'? This action cannot be undone.")) {
                 this.filtersList.splice(ir, 1);
             }
         },
         saveFilter(filter) {
             let i = this.filtersList.findIndex(function (e) {
                 return e.id === filter.id;
             });
             if (i > -1) {
                 this.filtersList[i] = filter;
             }
             else {
                 this.filtersList.push(filter);
             }
             this.showFilterModal = false;
         },
         fetchInitialData () {
             this.fetchFields();
             this.fetchFilters();
         },
         fetchFields() {
             var self = this;
             API.fields.getList()
                .then(function (response) {
                    self.fields = response.data;
                });
         },
         fetchFilters() {
             var self = this;
             API.scoringModelRules.getList()
                .then(function (response) {
                    if (response.data.results) {
                        self.filtersList = response.data.results;
                    }
                });
         },
         toggleFilterModal (filterModel) {
             if (filterModel) {
                 this.filter = filterModel;
             }
             else {
                 this.filter = undefined;
             }
             this.showFilterModal = true;
         },
         saveTable() {
             var self = this;
             API.scoringModelRules.create(
                 this.filtersList.map(function (item, index) {
                     item.priority = index + 1;
                     return item;
                 })
             ).then(function (response) {
                 self.filtersList = response.data;
                 Vue.toast('Changes saved successfully!', {
                     className: ['et-info'],
                 });
             },
                    (err) => {
                        Vue.toast('An unexpected error happened. Please contact support.', {
                            className: ['et-error'],
                        });
             });
         },
     }
 }
</script>


<style scoped>
 .content {
     padding-bottom: 20px;
 }


 .filter {
     border-radius: 4px 4px;
     background-color: #f5fff0;
     border: 1px solid #ddd;
     padding: 20px;
     margin-bottom: 20px;
 }

 .filter-reject {
     background-color: #fff0f0;
 }

 .filter-disabled {
     background-color: #f3f3f3;
 }



 .rules {
     display: flex;
     flex-wrap: wrap;
     padding: 10px 10px;
     border: 1px solid #ddd;
     border-radius: 4px 4px;
     background: #f9feff;
 }

 .anyof-header {
     font-weight: 600;
     padding: 5px;
     text-align: center;
 }

 .rules-header {
     flex-basis: 100%;
     font-weight: 600;
 }

 .rule-wrapper {
     flex-basis: 20%;
     flex-shrink: 1;
     flex-grow: none;
     height: 180px;
     background: #dedede;
     border: 1px solid #ddd;
     border-radius: 4px 4px;
     display: flex;
     justify-content: center;
     align-items: center;
     margin: 5px;
     padding: 10px 0px 10px 0px;
 }

 .rule-wrapper:last-child {
     margin-right: 0px;
 }

 .rule-definition {
     background: #fff;
     border-radius: 4px 4px;
     border: 1px solid #ddd;
     display: flex;
     flex-direction: column;
     height: 100%;
     align-items: center;
     justify-content: flex-start;
     min-width: 140px;
     flex-grow: 1;
     flex-shrink: 1;
     flex-basis: auto;
 }

 .rule-controls {
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;

 }

 .condition-controls {
     width: 100%;
     display: flex;
     justify-content: space-between;
 }

 .filter-controls {
     margin-bottom: -24px;
 }

 .filter-controls .btn,
 .condition-controls .btn,
 .rule-controls .btn {
     background: transparent;
 }

 .rule-body {
     width: 100%;
     padding: 5px;
     align-items: center;
     display: flex;
     justify-content: flex-start;
     flex-direction: column;
     flex-grow: 1;
 }
 .rule-op {
     color: #555;
     margin-bottom: 3px;
 }
 .rule-field {
     font-weight: 600;
     font-size: 1.1em;
 }
 .add-rule {
     margin-right: 5px;
 }

 h3 .btn {
     margin-top: -10px;
 }

 .rule-values li,
 .rule-values span {
     font-size: 1.1em;
     border-radius: 4px 4px 4px 4px;
     color: #000;
     font-weight: 400;
     padding: 2px 4px;
     display: inline-block;
     background-color: #f9dbdb;
 }
 .rule-values li + li {
     margin-left: 3px;
  }

  ul.list-inline {
    display: inline-block;
  }

  ul.list-inline li + li:before {
    content: ', ';
    margin-left: -.5rem;
  }
</style>



// WEBPACK FOOTER //
// ScoringModelRulesSettings.vue?1aad4428